<template>
    <div>
<!--        <a-drawer-->
<!--            :title='title'-->
<!--            :visible="visible"-->
<!--            v-bind="drawerConfig"-->
<!--            :body-style="{ paddingBottom: '80px' }"-->
<!--            @close="onClose"-->
<!--    >-->
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="seo_url"
                    label="URL"
                    prop="seo_url"
                    :help="formErr.seo_url"
                    :validateStatus='!formErr.seo_url||formErr.seo_url==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.seo_url"
                        @change="(e) => { formErr.seo_url=''}"
                        @blur="(e) => {  form.seo_url = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="seo_title"
                    label="SEO标题"
                    prop="seo_title"
                    :help="formErr.seo_title"
                    :validateStatus='!formErr.seo_title||formErr.seo_title==""?"":"error"'
            >
                <a-input
                        :maxLength=110
                        v-model="form.seo_title"
                        @change="(e) => { formErr.seo_title=''}"
                        @blur="(e) => {  form.seo_title = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="seo_keywords"
                    label="SEO关键词"
                    prop="seo_keywords"
                    :help="formErr.seo_keywords"
                    :validateStatus='!formErr.seo_keywords||formErr.seo_keywords==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.seo_keywords"
                        @change="(e) => { formErr.seo_keywords=''}"
                        @blur="(e) => {  form.seo_keywords = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="seo_description"
                    label="SEO描述"
                    prop="seo_description"
                    :help="formErr.seo_description"
                    :validateStatus='!formErr.seo_description||formErr.seo_description==""?"":"error"'
            >
                <a-textarea  :rows="4" v-model="form.seo_description"  :maxLength=400
                             @change="(e) => { formErr.seo_description=''}"
                             @blur="(e) => {  form.seo_description = e.target.value.trim() }"/>
            </a-form-model-item>
            <a-form-model-item
                    ref="thumb"
                    label="缩略图"
                    prop="thumb"
                    :help="formErr.thumb"
                    :validateStatus='!formErr.thumb||formErr.thumb==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:1}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
            </a-form-model-item>
            <a-form-model-item
                    ref="abstract"
                    label="摘要"
                    prop="abstract"
                    :help="formErr.abstract"
                    :validateStatus='!formErr.abstract||formErr.abstract==""?"":"error"'
            >
                <a-textarea  :rows="4" v-model="form.abstract"  :maxLength=400
                             @change="(e) => { formErr.abstract=''}"
                             @blur="(e) => {  form.abstract = e.target.value.trim() }"/>
            </a-form-model-item>


            <a-form-model-item
                    ref="content"
                    label="内容"
                    prop="content"
                    :help="formErr.content"
                    :validateStatus='!formErr.content||formErr.content==""?"":"error"'
            >
            <ckeditor4 ref="ckeditor"  :value="contenta" v-on:input="ckeditorContent" @instanceReadyCk="instanceReadyCk "></ckeditor4>
            </a-form-model-item>
            <a-form-model-item
                    ref="release_time"
                    label="发布时间"
                    prop="release_time"
                    :help="formErr.release_time"
                    :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'
            >
                <a-date-picker show-time placeholder="Select Time" :format="dateFormat" :defaultValue="deforDate"  v-model="form.release_time" />

            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="(item, idx) in this.seleList.status" :key="idx"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item
                    ref="is_top"
                    label="置顶"
                    prop="is_top"
                    :extra="formErr.is_top"
                    :validateStatus='!formErr.is_top||formErr.is_top==""?"":"error"'
            >
                <a-switch   defaultChecked v-model="form.is_top" />
            </a-form-model-item>

            <a-form-model-item>
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            取消
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>
<!--    </a-drawer>-->
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator,beforeUpload} from "../../../utils/utils"
    import ckeditor4 from '../../Components/ckeditors'
    import API from "../api";
    import moment from 'moment';
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            content: {
                type: String,
                default: '请输入您的内容'
            }
        },
        data() {
            return {
                id: this.$route.query.id,
                contenta: "",
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                fileList:[],
                seleList:[],
                drawerConfig ,
                previewVisible: false,
                previewImage: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                form: {
                    name:"",
                    seo_url:"",
                    seo_title:"",
                    seo_description:"",
                    seo_keywords:"",
                    thumb:"",
                    abstract:"",
                    content:"",
                    status:1,
                    release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    is_top:true,
                },
                formErr: {
                    name:"",
                    seo_url:"",
                    seo_title:"",
                    seo_description:"",
                    seo_keywords:"",
                    thumb:"",
                    abstract:"",
                    content:"",
                    status:"",
                    release_time:"",
                    is_top:"",
                },
                rules: {
                    seo_url: [{required: true, message: "请输入链接地址 ",  }, {  whitespace: true, message: "请输入链接地址 " },{type:"url", message: "请填写正确链接地址"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.seo_url)}  , trigger: "blur"  },],
                    name: [{required: true, message: "请输入标题 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    // thumb:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb)}  , trigger: "blur"  },],

                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span: 14 },
                },
            };
        },
        components:{ckeditor4},
        created() {
            this.$store.state.adminleftnavnum = "/NewsManagement/NewsManagementList"; //设置左侧导航2-2 active
        },
        mounted(){

            let _that=this
            // this.$nextTick().then(function () {
            //     if(_that.id!=undefined){ _that.editform(_that.id)}
            // })
            this.getFormData()
        },
        updated(){
            let _that=this
            // this.$nextTick().then(function () {
            //     if(_that.id!=undefined){ _that.editform(_that.id)}
            // })
        },
        computed: {
            deforDate: function () {
                return moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
            }
        },
        methods: {
            instanceReadyCk(type){
                if(type==true){
                    let _that=this
                    this.$nextTick().then(function () {
                        if(_that.id!=undefined){ _that.editform(_that.id)}
                    })
                }
                  // this.id!=undefined&&this.editform(this.id)
                },
            onClose(){
                this.$router.push({path: '/NewsManagement/NewsManagementList'})
            },
            editform(id){
                API.service.EDIT_DATA(id).then(res => {
                    let data=res.data.data.info
                    data.is_top==0?data.is_top=false:data.is_top=true
                    data.status= data.status
                    data.release_time=moment(res.data.data.info.release_time, 'YYYY-MM-DD HH:mm:ss')
                    this.form = data
                    if (this.form.thumb == "") {
                        this.fileList = []
                    } else {
                        this.fileList = [
                            {uid: this.form.thumb,
                                name: this.form.thumb,
                                status: "done",
                                url: this.form.thumb ? this.form.thumb : ""
                            }
                        ]
                    }
                    let _that=this
                    this.$nextTick().then(function () {
                            _that.contenta = data.content_text
                        })
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.contenta = data.content_text
                    //     }, 800)
                    // })

                    this.form.id=this.id
                })
            },
            ckeditorContent(val) {
                this.form.content = val
            },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList=res.data.data
                })
            },

            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ) {
                let {fileList} = info;
                const status = info.file.status;

                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.formErr.thumb=""
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.formErr.thumb=""
                        this.fileList= fileList
                    });
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
               return  beforeUpload(file)
                // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                // if (!isJpgOrPng) {
                //     this.$message.error('只能上传jpg，png类型图片!');
                //     return false
                // }
                // const isLt2M = file.size / 1024 / 1024 < 2;
                // if (!isLt2M) {
                //     this.$message.error('图片必须小于 2MB!');
                //     return false
                // }
                // return new Promise(function (resolve,reject) {
                //     resolve(file)
                // })
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onSubmit() {
                let _this = this;
                // if (this.fileList.length < 1) {
                //     _this.formErr.thumb = "缩略图不能为空";
                //     return
                // } else {
                //     _this.formErr.thumb = "";
                //     this.form.thumb = this.fileList[0].url
                // }
                this.$refs.ckeditor.$emit("getText")
                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.thumb = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.thumb = this.fileList[0].response.data.url
                } else {
                    this.form.thumb = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.is_top==true?subData.is_top=1:subData.is_top=0
                        subData.content_text=subData.content
                        subData.release_time!=""&&subData.release_time!=null?subData.release_time=moment(subData.release_time).format('YYYY-MM-DD HH:mm:ss'): subData.release_time=null
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                setTimeout(() => {
                                    this.onClose()
                                }, 1500)
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
</style>
